import { render, staticRenderFns } from "./BlockedSlotDialog.vue?vue&type=template&id=0e2a4cba&scoped=true"
import script from "./BlockedSlotDialog.vue?vue&type=script&lang=js"
export * from "./BlockedSlotDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2a4cba",
  null
  
)

export default component.exports